import { PropsWithChildren, ReactNode, forwardRef, useEffect, useMemo } from 'react';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { useListenMessage } from '@application/hooks/useListenMessage';
import { MSG_NAME_TO_IFRAME } from '@src/container/handleIframeMessage/handleIframeMessage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LayoutBase } from './LayoutBase/LayoutBase';
import { NavigationItem } from '@src/application/modules/tag/Header/types';
import { QARoute } from '../type';
import { onQaAssistantClosing } from '../util';

const useAnalytics = () => {
  const segmentTrack = useSegmentTrack();

  // Track close action from container
  useListenMessage(
    ({ data }) => {
      if (data.name === MSG_NAME_TO_IFRAME.SegmentClickClosing) {
        onQaAssistantClosing();
        segmentTrack('Qa - Click closing button');
      }
    },
    [segmentTrack]
  );

  useEffect(() => {
    segmentTrack('Qa - Qa mode launch success');
  }, []);
};

type LayoutProps = {
  children: ReactNode;
  routes: QARoute[];
};

type HeaderSearchProps = {
  routes: QARoute[];
};

const HeaderSearch = ({ routes }: HeaderSearchProps) => {
  return () => (
    <Routes>
      {routes.map(({ path, searchField }) => (
        <Route key={path} path={path} element={searchField} />
      ))}
    </Routes>
  );
};

export const Layout = forwardRef<HTMLDivElement, PropsWithChildren<LayoutProps>>(({ children, routes }, ref) => {
  useAnalytics();

  const HeaderSearchField = useMemo(() => HeaderSearch({ routes }), []);

  const navigationItems: NavigationItem[] = routes.map(({ navigationName: name, path, key, desktopOnly }) => ({
    name,
    path,
    key,
    desktopOnly,
  }));
  return (
    <BrowserRouter>
      <LayoutBase ref={ref} HeaderSearchField={HeaderSearchField} navigationItems={navigationItems}>
        {children}
      </LayoutBase>
    </BrowserRouter>
  );
});
